module.exports = __webpack_public_path__ + "img/newsImg8-1.deed44c5.png";